// extracted by mini-css-extract-plugin
export default {"flexi":"UsersView_flexi_MuPAb"};